import styles from './CommentBox.module.css'
import { FormEvent, useEffect, useState } from 'react' // Fragment,
import {
  // EmojiHappyIcon,
  // EmojiSadIcon,
  // FireIcon,
  // HeartIcon,
  // PaperClipIcon,
  // ThumbUpIcon,
  XIcon,
  ChatAltIcon,
} from '@heroicons/react/solid'
// import { Listbox, Transition } from '@headlessui/react'
// import { ChatAltIcon } from '@heroicons/react/outline'
import { useUser } from 'data/users/client'
import LoadingButton from 'components/LoadingButton'
import Clickable from 'components/Clickable'
import LoginCommenter from 'components/LoginCommenter'
// import { isNil } from 'lodash'
// import { post } from 'utilities/api'
import { TweetReplyToCreateInternal } from 'data/twitter/types'
import Button from 'components/Button'
// import ProfileImageWithFallback from 'components/ProfileImageWithFallback'
import { createCommentForConversation } from 'data/conversations/client'
import { KeyedMutator } from 'swr'
import TweetInput from 'components/TweetInput'
import { isAutoGeneratedTweetId } from 'data/comments/client'
import Link from 'components/Link'

// const moods = [
//   { name: 'Excited', value: 'excited', icon: FireIcon, iconColor: 'text-white', bgColor: 'bg-red-500' },
//   { name: 'Loved', value: 'loved', icon: HeartIcon, iconColor: 'text-white', bgColor: 'bg-pink-400' },
//   { name: 'Happy', value: 'happy', icon: EmojiHappyIcon, iconColor: 'text-white', bgColor: 'bg-green-400' },
//   { name: 'Sad', value: 'sad', icon: EmojiSadIcon, iconColor: 'text-white', bgColor: 'bg-yellow-400' },
//   { name: 'Thumbsy', value: 'thumbsy', icon: ThumbUpIcon, iconColor: 'text-white', bgColor: 'bg-blue-500' },
//   { name: 'I feel nothing', value: null, icon: XIcon, iconColor: 'text-gray-400', bgColor: 'bg-transparent' },
// ]

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

type Props = {
  replyTo: string,
  updateConversations?: KeyedMutator<any>,
  tweetUrl?: string,
}

const CommentBox = ({
  replyTo,
  updateConversations,
  tweetUrl,
}: Props) => {
  // const [selected, setSelected] = useState(moods[5])
  const { user } = useUser()
  const [commentText, setCommentText] = useState('')
  const [isCommentSubmitting, setIsCommentSubmitting] = useState(false)
  const [isCommentSubmitted, setIsCommentSubmitted] = useState(false)
  const [isFirstTime, setIsFirstTime] = useState(false)
  // const isStartingNewConversation = isAutoGeneratedTweetId(replyTo)
  const isShowingLogin = isCommentSubmitting && !user
  // console.log({ isShowingLogin, user: user, notIsUserLoading: !isUserLoading })
  const isShowingFirstPostMessage = !user?.hasCommentedViaBlotter
  // const isShowingPreview = isCommentSubmitting && !isShowingLogin && !isShowingFirstPostMessage
  const handleCommentFormSubmission = (e?: FormEvent<HTMLFormElement> | MouseEvent) => {
    e?.preventDefault()
    if (user?.hasCommentedViaBlotter) {
      submitCommentFinal()
    } else {
      setIsCommentSubmitting(true)
    }
  }
  const submitCommentFinal = async () => {
    if (!commentText) return false
    setIsCommentSubmitted(true)
    recordFirstTime()
    const tweetContent: TweetReplyToCreateInternal = {
      text: commentText,
      replyToBlotterId: replyTo,
    }
    const createdComment = await createCommentForConversation(tweetContent)
    if (createdComment) {
      if (updateConversations) {
        updateConversations()
      }
      setIsCommentSubmitting(false)
      setIsCommentSubmitted(false)
      setCommentText('')
    }
  }
  const cancelSubmitting = () => {
    setIsCommentSubmitting(false)
  }
  const recordFirstTime = () => {
    setIsFirstTime(false)
  }
  useEffect(() => {
    if (!isFirstTime && user && !user?.hasCommentedViaBlotter) {
      setIsFirstTime(true)
    }
  }, [user])
  if (!replyTo) {
    return null
  }
  return <div className={isCommentSubmitting ? styles.commentBoxWithSubmitting : styles.commentBox}>
    { isCommentSubmitting &&
      <div className={classNames(isCommentSubmitted ? styles.submittingContainerHidden : styles.submittingContainerVisible, styles.backdropBlur)}>
        <div className={styles.submitting}>
          { !isCommentSubmitted && <Clickable
            className={styles.closeSubmitting}
            onClick={cancelSubmitting}
          >
            <XIcon width={24} height={24} color='#777c' />
          </Clickable> }
          { (isShowingLogin || isShowingFirstPostMessage) &&
            <div className={styles.login}>
              <FirstPostMessage tweetUrl={tweetUrl} />
              { isShowingLogin
                ? <div><LoginCommenter commentData={{
                  commentText,
                  replyToBlotterId: replyTo,
                }} /></div>
                : <div className='my-4 mt-8 w-full flex justify-end'>
                  <Button
                    className='relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2'
                    onClick={() => { submitCommentFinal() }}
                    isDisabled={!commentText}
                  >
                    Got it, publish my reply &raquo;
                  </Button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    <TweetInput
      user={user}
      text={commentText}
      setText={setCommentText}
      handleSubmit={handleCommentFormSubmission}
      placeholder='Add your reply'
      buttonLabel='Post My reply'
      isDisabled={isCommentSubmitted || !commentText}
      isWorking={isCommentSubmitted}
      buttonLabelWorking='Posting…'
    />
  </div>
}

const FirstPostMessage = ({ tweetUrl }: { tweetUrl: string }) =>
  <div className={styles.preview}>
    <h2 className={styles.previewHeadline}>Your first time?</h2>
    <p>Thanks for adding your reply! A couple of things you should&nbsp;know:</p>
    <h3 className={styles.previewHeading}>Our Comment Section is Different</h3>
    <p>This comment section is connected to Twitter. This means your post will appear both here on this page and also as a reply to our&nbsp;Tweet{ tweetUrl && <>(<Link href={tweetUrl}>view it on Twitter</Link>)</> }.</p>
    <h3 className={styles.previewHeading}>Why?</h3>
    <p>We want our comment section to inspire honest-to-goodness — yet concise — discussion. Less spam, more conversation. Twitter helps that&nbsp;happen.</p>
  </div>

export default CommentBox
